import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-full-page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-full-page__animation" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-full-page__subtext spinner-full-page__subtext__receipt" }, "Øjeblik...", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReceiptComponent = _resolveComponent("ReceiptComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showSpinner)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_ReceiptComponent, { model: _ctx.model }, null, 8, ["model"])
  ], 64))
}